import { render, staticRenderFns } from "./InteractiveImage_Header.vue?vue&type=template&id=064ac866&"
import script from "./InteractiveImage_Header.vue?vue&type=script&lang=js&"
export * from "./InteractiveImage_Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports